/* eslint-disable consistent-return */
import { apiContainer } from '@vlabs/api-bindings';

export async function enrichDataWithListOptions(
  events: Record<string, unknown>[] = [],
  listOptions: Record<string, unknown>[] = [],
): Promise<Record<string, unknown>[] | undefined> {
  if (!events.length || !listOptions.length) return;

  const enriched = await Promise.all(
    events.map(async (event) => {
      try {
        const type = event.top_match?.face_id ? 'face' : 'event';
        const dataId = event.top_match?.face_id ?? event.top_match?.event_id;

        if (!event.listOptions && type && dataId && !event.event_type) {
          const { data } = await apiContainer.lunaClient[type === 'face' ? 'faces' : 'events'].get(dataId);
          return {
            ...event,
            listOptions: data.lists?.map((faceListId) => listOptions.find(({ value }) => value === faceListId)
              ?? { label: faceListId, value: faceListId }),
          };
        }
        return event;
      } catch {
        return event;
      }
    }),
  );

  return enriched;
}
